import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: MenuLabel
name: MenuLabel
category: React - Bulma
parent: Menu
---

A `MenuLabel` component based on Bulma `.menu-label`. This is used to add a
title to the `Menu` component.

This should be used as a child of the `Menu` component.

See [Bulma Documentation](http://bulma.io/documentation/components/menu/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name       | Description                                 |Type            | Default Value             | Required?     |
|-----------------|---------------------------------------------|----------------|---------------------------|---------------|
| label           | Menu label text                             | string         |                           | yes            |

```html_example
  <Menu>
    <MenuLabel label="Hello." />
  </Menu>
```
*/
function MenuLabel(props) {
  const {
    children, className, label, ...rest
  } = props

  const classes = [
    'menu-label',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {label || children}
    </div>
  )
}

MenuLabel.propTypes = {
  // Text to display instead of children components
  label: PropTypes.string,
}

export default MenuLabel
